import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import { FirebaseMain } from '../firebase';
import firebaseNode from '../firebaseNode';


const SET_ROOM_DATA_READY = 'cam4/firebaseWatchers/roomState/SET_ROOM_DATA_READY';
const UPDATE_ONLINE_STATE = 'cam4/firebaseWatchers/roomState/UPDATE_ONLINE_STATE';
const UPDATE_NEW_SHOWS_STATE = 'cam4/firebaseWatchers/roomState/UPDATE_NEW_SHOWS_STATE';
const UPDATE_STATUS = 'cam4/firebaseWatchers/roomState/UPDATE_STATUS';
const UPDATE_PRIVATE_ROOM_STATE = 'cam4/firebaseWatchers/roomState/UPDATE_PRIVATE_ROOM_STATE';
const UPDATE_DISCONNECT_TIMESTAMP = 'cam4/firebaseWatchers/roomState/UPDATE_DISCONNECT_TIMESTAMP';
const UPDATE_NEW_SHOWS_DETAILS = 'cam4/firebaseWatchers/roomState/UPDATE_NEW_SHOWS_DETAILS';
const CREATE_INITIAL_DATA = 'cam4/firebaseWatchers/roomState/CREATE_INITIAL_DATA';
const RESET_STATE = 'cam4/firebaseWatchers/roomState/RESET_STATE';
const UPDATE_PRIVATE_SHOW_REQUEST = 'cam4/firebaseWatchers/roomState/UPDATE_PRIVATE_SHOW_REQUEST';
const UPDATE_KIIROOROOM_STATE = 'cam4/firebaseWatchers/roomState/UPDATE_KIIROOROOM_STATE';
const UPDATE_USER_COUNT_LIGTH = 'cam4/firebaseWatchers/roomState/UPDATE_USER_COUNT_LIGTH';

export const NAME = 'roomState';

/*
INITIAL STATE
*/
const initialState = Immutable.fromJS({
  roomDataReady: false,
  allowCamToCam: null,
  allowPrivateShow: null,
  allowSpyShow: null,
  broadcastId: null,
  broadcastType: null,
  fanclubImageId: null,
  mbaOrientation: null,
  mbaVersion: null,
  newShowsState: null,
  online: null,
  originUrl: null,
  privateRoom: null,
  privateShowBlocksOfTime: null,
  privateShowBlocksOfTimeActive: null,
  streamResolution: null,
  spyPricePerMinute: null,
  status: null,
  streamSource: null,
  streamUUID: null,
  tippingSessionId: null,
  uuid: null,
  viewerPricePerMinute: null,
  disconnectTimestamp: 0,
  kiirooRoom: false,
  newShowsDetails: null,
  isPrivateShowRequestActive: false,
  userCountLight: 0,
});

/*
REDUCER
*/
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ROOM_DATA_READY:
      return state.set('roomDataReady', action.roomDataReady);

    case CREATE_INITIAL_DATA:
      return state
        .set('allowCamToCam', action.roomState.allow_c2c)
        .set('allowPrivateShow', action.roomState.allow_ps)
        .set('allowSpyShow', action.roomState.allow_spy)
        .set('online', action.roomState.online)
        .set('privateRoom', action.roomState.privateRoom)
        .set('newShowsState', action.roomState.newShowsState)
        .set('status', action.roomState.status)
        .set('streamSource', action.roomState.streamSource)
        .set('fanclubImageId', action.roomState.fanclubImageId)
        .set('streamUUID', action.roomState.streamUUID)
        .set('uuid', action.roomState.uuid)
        .set('streamResolution', action.roomState.rez)
        .set('spyPricePerMinute', action.roomState.spy_ppm)
        .set('privateShowBlocksOfTime', action.roomState.ps_bt)
        .set('privateShowBlocksOfTimeActive', action.roomState.ps_bt_a)
        .set('viewerPricePerMinute', action.roomState.viewer_ppm)
        .set('originUrl', action.roomState.originUrl)
        .set('broadcastId', action.roomState.bId)
        .set('broadcastType', action.roomState.bType)
        .set('mbaOrientation', action.roomState.mba_o)
        .set('mbaVersion', action.roomState.mba_v)
        .set('tippingSessionId', action.roomState.tsId)
        .set('kiirooRoom', action.roomState.kiirooRoom ? JSON.parse(action.roomState.kiirooRoom) : false)
        .set('newShowsDetails', action.roomState.newShowsDetails);

    case UPDATE_ONLINE_STATE:
      return state.set('online', action.online);

    case UPDATE_NEW_SHOWS_STATE:
      return state.set('newShowsState', action.newShowsState);

    case UPDATE_PRIVATE_ROOM_STATE:
      return state.set('privateRoom', action.privateRoom);

    case UPDATE_STATUS:
      return state.set('status', action.status);

    case UPDATE_DISCONNECT_TIMESTAMP:
      return state.set('disconnectTimestamp', action.disconnectTimestamp);

    case UPDATE_NEW_SHOWS_DETAILS:
      return state.set('newShowsDetails', action.newShowsDetails);

    case RESET_STATE:
      return initialState;

    case UPDATE_PRIVATE_SHOW_REQUEST:
      return state.set('isPrivateShowRequestActive', action.payload);

    case UPDATE_KIIROOROOM_STATE:
      return state.set('kiirooRoom', JSON.parse(action.newKiiroRoom));

    case UPDATE_USER_COUNT_LIGTH:
      return state.set('userCountLight', action.count);

    default:
      return state;
  }
}

/*
INPUT SELECTORS
*/

const roomDataReady = (state) => state[NAME].get('roomDataReady');
const allowCamToCam = (state) => state[NAME].get('allowCamToCam');
const allowPrivateShow = (state) => state[NAME].get('allowPrivateShow');
const allowSpyShow = (state) => state[NAME].get('allowSpyShow');
const online = (state) => state[NAME].get('online');
const newShowsState = (state) => state[NAME].get('newShowsState');
const status = (state) => state[NAME].get('status');
const privateRoom = (state) => state[NAME].get('privateRoom');
const streamSource = (state) => state[NAME].get('streamSource');
const fanclubImageId = (state) => state[NAME].get('fanclubImageId');
const streamUUID = (state) => state[NAME].get('streamUUID');
const uuid = (state) => state[NAME].get('uuid');
const streamResolution = (state) => state[NAME].get('streamResolution');
const spyPricePerMinute = (state) => state[NAME].get('spyPricePerMinute');
const privateShowBlocksOfTime = (state) => state[NAME].get('privateShowBlocksOfTime');
const privateShowBlocksOfTimeActive = (state) => state[NAME].get('privateShowBlocksOfTimeActive');
const viewerPricePerMinute = (state) => state[NAME].get('viewerPricePerMinute');
const originUrl = (state) => state[NAME].get('originUrl');
const broadcastId = (state) => state[NAME].get('broadcastId');
const broadcastType = (state) => state[NAME].get('broadcastType');
const mbaOrientation = (state) => state[NAME].get('mbaOrientation');
const mbaVersion = (state) => state[NAME].get('mbaVersion');
const tippingSessionId = (state) => state[NAME].get('tippingSessionId');
const disconnectTimestamp = (state) => state[NAME].get('disconnectTimestamp');
const kiirooRoom = (state) => state[NAME].get('kiirooRoom');
const newShowsDetails = (state) => state[NAME].get('newShowsDetails');
const isPrivateShowRequestActive = (state) => state[NAME].get('isPrivateShowRequestActive');
const userCountLight = (state) => state[NAME].get('userCountLight');

/*
ACTIONS
*/

function setRoomDataReady(roomDataReady) {
  return {
    type: SET_ROOM_DATA_READY,
    roomDataReady,
  };
}

function updateOnlineState(online) {
  return {
    type: UPDATE_ONLINE_STATE,
    online,
  };
}

function updateNewShowsState(newShowsState) {
  return {
    type: UPDATE_NEW_SHOWS_STATE,
    newShowsState,
  };
}

function updateStatus(status) {
  return {
    type: UPDATE_STATUS,
    status,
  };
}

function updatePrivateRoomState(privateRoom) {
  return {
    type: UPDATE_PRIVATE_ROOM_STATE,
    privateRoom,
  };
}

function populateInitialData(roomState) {
  return {
    type: CREATE_INITIAL_DATA,
    roomState,
  };
}

function stateToInitialValues() {
  return { type: RESET_STATE };
}

function updateDisconnectTimeStamp(disconnectTimestamp) {
  return {
    type: UPDATE_DISCONNECT_TIMESTAMP,
    disconnectTimestamp,
  };
}

function updateNewShowsDetails(newShowsDetails) {
  return {
    type: UPDATE_NEW_SHOWS_DETAILS,
    newShowsDetails,
  };
}

function updateKirooRoom(newKiiroRoom) {
  return {
    type: UPDATE_KIIROOROOM_STATE,
    newKiiroRoom,
  };
}

function updateUserCountLight(count) {
  return {
    type: UPDATE_USER_COUNT_LIGTH,
    count,
  };
}

function monitorViewerCount(count, dispatch) {
  if (count !== null) {
    const splitIndex = count.indexOf('$');
    const totalLoggedInUsers = parseInt(count.substring(0, splitIndex), 10);
    const globalTotalGuests = parseInt(count.substring(splitIndex + 1), 10);
    const totalUsers = totalLoggedInUsers + globalTotalGuests;
    dispatch(updateUserCountLight(totalUsers));
  }
}

// revert state to initial values
function resetRoomState() {
  return (dispatch) => {
    dispatch(stateToInitialValues());
  };
}

function updateIsPrivateShowRequestActive(payload) {
  return {
    type: UPDATE_PRIVATE_SHOW_REQUEST,
    payload,
  };
}

function watchPrivateShowRequest(roomName, username) {
  const privateShowRequestRef = FirebaseMain.child(
    `${firebaseNode.PRIVATE_SHOW_REQUESTS}/${roomName.toLowerCase()}/${username.toLowerCase()}`
  );

  return (dispatch) => {
    privateShowRequestRef.on('value', (snapshot) => {
      dispatch(updateIsPrivateShowRequestActive(snapshot.exists()));
    });
  };
}

/*
WATCHERS
*/
function watchRoomState(roomName, username) {
  const roomStateRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState`);
  const onlineStateRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/online`);
  const newShowsStateRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/newShowsState`);
  const statusRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/status`);
  const privateRoomRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/privateRoom`);
  const disconnectTimestampRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/dTS`);
  const newShowsDetailsRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/newShowsDetails`);

  const kiirooRoomRef = FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState/kiirooRoom`);

  const chatlessRoomUserCountRefLight = FirebaseMain.child(
    `${firebaseNode.CHATLESS_ROOM_USER_COUNT_LIGHT}/${roomName}`
  );

  return (dispatch) => {
    if (username) {
      watchPrivateShowRequest(roomName, username)(dispatch);
    }

    // store all data that is never updated
    roomStateRef
      .once('value', (snapshot) => {
        dispatch(populateInitialData(snapshot.val()));
      })
      .then(() => {
        dispatch(setRoomDataReady(true));
        roomStateRef.on('value', (snapshot) => {
          dispatch(populateInitialData(snapshot.val()));
        });
        onlineStateRef.on('value', (snapshot) => {
          dispatch(updateOnlineState(snapshot.val()));
        });
        newShowsStateRef.on('value', (snapshot) => {
          dispatch(updateNewShowsState(snapshot.val()));
        });
        statusRef.on('value', (snapshot) => {
          dispatch(updateStatus(snapshot.val()));
        });
        privateRoomRef.on('value', (snapshot) => {
          dispatch(updatePrivateRoomState(snapshot.val()));
        });
        disconnectTimestampRef.on('value', (snapshot) => {
          dispatch(updateDisconnectTimeStamp(snapshot.val()));
        });
        newShowsDetailsRef.on('value', (snapshot) => {
          dispatch(updateNewShowsDetails(snapshot.val()));
        });
        kiirooRoomRef.on('value', (snapshot) => {
          dispatch(updateKirooRoom(snapshot.val()));
        });
        chatlessRoomUserCountRefLight.on('value', (snapshot) => {
          monitorViewerCount(snapshot.val(), dispatch);
        });
      });
  };
}

/*
EXPORTS
*/
export const selector = createStructuredSelector({
  roomState: createStructuredSelector({
    roomDataReady,
    allowCamToCam,
    allowPrivateShow,
    allowSpyShow,
    online,
    newShowsState,
    status,
    privateRoom,
    streamSource,
    fanclubImageId,
    streamUUID,
    uuid,
    streamResolution,
    spyPricePerMinute,
    privateShowBlocksOfTime,
    privateShowBlocksOfTimeActive,
    viewerPricePerMinute,
    originUrl,
    broadcastId,
    broadcastType,
    mbaOrientation,
    mbaVersion,
    tippingSessionId,
    disconnectTimestamp,
    kiirooRoom,
    newShowsDetails,
    isPrivateShowRequestActive,
    userCountLight,
  }),
});

export const actionCreators = {
  watchRoomState,
  resetRoomState,
  watchPrivateShowRequest,
};
